<div class="transition-partial">
  <transition-card></transition-card>
</div>
